<template>
  <div>
    <template v-if="width < 2054 && width > 1699">
      <vs-row justify="flex-end">
        <vs-col :key="index" v-for="(col, index) in 3" w="2"><br/></vs-col>
      </vs-row>
    </template>
    <vx-card title="병원정보">
      <div class="vx-row mb-3">
        <div class="vx-col w-full lg:w-1/1 ">
          <vs-button type="line" :class="{active: isActive1}" @click="tabChange(1)">직원 연락처</vs-button>
        </div>
      </div>

      <vs-table :max-items="cutPage" :data="list" :noDataText="'데이터가 존재하지 않습니다.'">
        <template slot="thead">
          <vs-th class="table_header" width="10%">팀명</vs-th>
          <vs-th class="table_header" width="10%">세부소속</vs-th>
          <vs-th class="table_header" width="10%">이름</vs-th>
          <vs-th class="table_header" width="10%">직함</vs-th>
          <vs-th class="table_header" width="10%">휴대전화 번호</vs-th>
          <vs-th class="table_header" width="10%">내선 번호</vs-th>
          <vs-th class="table_header" width="10%">070번호</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, index) in data" :key="index">
            <vs-td>{{ tr.TEAM_NM }}</vs-td>
            <vs-td>{{ tr.DEPARTMENT_NM }}</vs-td>
            <vs-td>{{ tr.USERNAME }}</vs-td>
            <vs-td>{{ tr.POSITION_NM }}</vs-td>
            <vs-td>{{ tr.PHONE }}</vs-td>
            <vs-td>{{ tr.PHONE_EXTENSION }}</vs-td>
            <vs-td>{{ tr.PHONE_070 }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <br/>
      <vs-pagination :total="pageCount" v-model="curPage" @input="adminList" :max="7"></vs-pagination>
    </vx-card>
  </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import store from '../../store/store';
import VueCookies from 'vue-cookies';

export default {
  data() {
    return {
      search: '',
      curPage: 1,
      cutPage: 10,
      list: [],
      tablist: [],
      pageCount: 0,
      level_list: [],
      team_list: [],
      department_list: [],
      position_list: [],

      width: window.innerWidth,

      tabIndex: 1,
      isActive1: true,
    };
  },
  methods: {
    handleResize(event) {
      this.width = window.innerWidth;
    },
    init() {
      //this.adminList();
    },
    async tabChange(tabIndex) {
      if (tabIndex == 1) {
        this.tabIndex = 1;
        this.isActive1 = true;
        this.isActive2 = false;
        this.isActive3 = false;
        this.isActive4 = false;
        this.isActive5 = false;
      }
    },
    async adminList() {
      let sendData = {
        curPage: this.curPage,
        cutPage: this.cutPage,
        search: this.search,
        level: this.level,
        uid: this.loginUid,
      };
      const {data} = await axiosClass.get('/api/management/adminList/contact', sendData, true);
      console.log('data:::', data);
      if (data.list[0].MSG) {
        const MSG = data.list[0].MSG;
        let err_msg = '';
        if (MSG == 'ERR_ACCESS') {
          err_msg = '접근 권한이 없습니다.';
        } else if (MSG == 'ERR_MEMBER') {
          err_msg = '존재하지 않는 유저입니다.';
        }
      } else {
        this.list = data.list;
        const maxPage = Math.ceil(data.list[0].ALL_COUNT / this.cutPage);
        this.pageCount = maxPage < 1 ? 1 : maxPage;
      }
      this.level_list = data.level_list;
      this.team_list = data.team_list;
      this.department_list = data.department_list;
      this.position_list = data.position_list;
      this.tablist = data.tab_list;
      this.tablist_onoff = data.tab_list_onoff;

      this.tablist_01 = data.tab_list_01;

      this.tablist_03 = data.tab_list_03;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.level = store.getters.getCDLEVEL;
    this.loginUid = store.getters.getUID;
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style>
.vx-card__title h4 {
  font-size: 15px;
}

#admin_popup .vx-card__header {
  padding: 10px 20px 0px 20px;
}

#admin_popup .vx-card__body {
  padding: 10px;
}

#admin_popup .vx-card__body .checkbox_x {
  margin: 2px;
}
</style>
